import { render, staticRenderFns } from "./OrganizationForm.vue?vue&type=template&id=b9fe98c6"
import script from "./OrganizationForm.vue?vue&type=script&lang=js"
export * from "./OrganizationForm.vue?vue&type=script&lang=js"
import style0 from "./OrganizationForm.vue?vue&type=style&index=0&id=b9fe98c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports